import { forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const UK_MOBILE_RE = /^\+44(7[1-9]\d{8})$/;

export function normalizeUkMobile(raw) {
  if (!raw) return "";
  let digits = raw.replace(/[^\d+]/g, "");
  if (digits.startsWith("+44")) digits = digits.slice(3);
  else if (digits.startsWith("44")) digits = digits.slice(2);
  else if (digits.startsWith("0")) digits = digits.slice(1);
  return "+44" + digits;
}

export function isValidUkMobile(raw) {
  return UK_MOBILE_RE.test(normalizeUkMobile(raw));
}

export const UkPhoneInput = forwardRef(function UkPhoneInput({ value, onChange, invalid, className, "data-testid": testId, ...props }, ref) {
  return (
    <div className="space-y-1">
      <div
        className={cn(
          "flex items-center overflow-hidden rounded-md border bg-background transition-colors",
          invalid ? "border-red-500 focus-within:ring-1 focus-within:ring-red-500" : "border-input focus-within:ring-1 focus-within:ring-brand",
          className
        )}
      >
        <span className="flex items-center gap-1.5 border-r border-input bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700 select-none">
          <svg viewBox="0 0 60 30" className="h-3.5 w-6 rounded-[2px] shadow-sm" aria-hidden="true">
            <clipPath id="uk-c"><path d="M0 0v30h60V0z" /></clipPath>
            <clipPath id="uk-d"><path d="M30 15h30v15zv15H0zH0V0zV0h30z" /></clipPath>
            <g clipPath="url(#uk-c)">
              <path d="M0 0v30h60V0z" fill="#012169" />
              <path d="M0 0l60 30m0-30L0 30" stroke="#fff" strokeWidth="6" />
              <path d="M0 0l60 30m0-30L0 30" clipPath="url(#uk-d)" stroke="#C8102E" strokeWidth="4" />
              <path d="M30 0v30M0 15h60" stroke="#fff" strokeWidth="10" />
              <path d="M30 0v30M0 15h60" stroke="#C8102E" strokeWidth="6" />
            </g>
          </svg>
          +44
        </span>
        <Input
          ref={ref}
          type="tel"
          inputMode="numeric"
          autoComplete="tel-national"
          placeholder="7123 456789"
          value={(value || "").replace(/^\+?44/, "").replace(/^0/, "")}
          onChange={(e) => {
            const digits = e.target.value.replace(/[^\d]/g, "").replace(/^44/, "").replace(/^0/, "").slice(0, 10);
            onChange({ target: { value: "+44" + digits } });
          }}
          className="border-0 shadow-none focus-visible:ring-0"
          data-testid={testId}
          {...props}
        />
      </div>
      <p className="text-xs text-slate-400">UK mobile numbers only — e.g. 7123 456789</p>
    </div>
  );
});
